import { Box, Button, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { FC } from 'react'
import { ViewStyle } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'
import { getString } from '../../util/languageStrings'
import { Colors, isOsMobile } from '../../util/util'
import { LinearGradientContainer } from '../LinearGradient'

interface ScreenLockInterface {
  onPress: () => void
  onCancel: () => void
  selectedAppLanguage: any
}
const ScreenLockDialog: FC<ScreenLockInterface> = ({ onPress, onCancel, selectedAppLanguage }: ScreenLockInterface) => {
  const w = useWindowDimensions()
  if (!isOsMobile()) {
    return null
  }
  return (
    <Box>
      <LinearGradientContainer
        customStyle={
          {
            alignItems: 'center',
            borderTopLeftRadius: 25,
            borderTopRightRadius: 25,
            overflow: 'hidden',
          } as ViewStyle
        }
        angle={106}
        useAngle={true}
        colorArray={['#f7e8d1', '#fefdfb']}
        direction="HORIZONTAL">
        <Box pv={35}>
          <SvgImage color={Colors.PRIMARY} imageName={'ProtectAccount'} />
        </Box>
      </LinearGradientContainer>
      <Box p={24} bg={'WHITE'}>
        <Spacer direction={'vertical'} size={8} />
        <Text fontFamily="JioType-Black" fontSize={24} lineHeight={32} letterSpacing={-0.12}>
          {getString(selectedAppLanguage, 'secureAccount')}
        </Text>
        <Spacer direction={'vertical'} size={8} />
        <Text fontFamily="JioType-Medium" fontSize={14} lineHeight={20} letterSpacing={-0.17}>
          {getString(selectedAppLanguage, 'screenLockHelperText')}
        </Text>
        <Spacer direction={'vertical'} size={32} />
        <Button type={'primary'} testID="enableScreenLock" onPress={onPress} isFull={true} isRound height={48}>
          <Text
            title={getString(selectedAppLanguage, 'enableScreenLock')}
            fontFamily={'JioType-Bold'}
            fontSize={16}
            letterSpacing={-0.08}
            color={'WHITE'}
          />
        </Button>
        <Spacer direction={'vertical'} size={16} />
        <Button
          type={'secondary'}
          testID="doItLater"
          onPress={onCancel}
          isFull={true}
          isRound
          height={48}
          underlayColor={'TRANSPARENT'}>
          <Text
            title={getString(selectedAppLanguage, 'doItLater')}
            fontFamily={'JioType-Bold'}
            fontSize={16}
            letterSpacing={-0.08}
            color={'PRIMARY'}
          />
        </Button>
      </Box>
    </Box>
  )
}

export { ScreenLockDialog }
